// extracted by mini-css-extract-plugin
export default {"item_wrapper":"publisher-image-list_item_wrapper__+SqIv","items_container":"publisher-image-list_items_container__bNnSB"};